// extracted by mini-css-extract-plugin
export default {"ImageCube":"ImageCube_ImageCube__zb6lb"};